import { Component, ComponentFactoryResolver, OnDestroy, OnInit } from '@angular/core';
import { BroadcastService, ModalService, ModalSize, SubContent } from '@cv-invision/core';
import { ORIGIN } from '../../model/nexsys-monitor.constant';
import { RequestInformationLogComponent } from '../request-information-log/request-information-log.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'cv-nexsys-log-description',
	templateUrl: './logs-description.component.html',
	styleUrls: ['./logs-description.component.scss']
})
export class LogsOrderDescriptionComponent extends SubContent implements OnInit, OnDestroy {
	private atComponentDestroy: Subject<any> = new Subject<any>();
	OrderBaseLog: any;
	OrderTransLog: any;
	logsInputs: any;
	constructor(
		broadcastService: BroadcastService,
		private modalService: ModalService,
		private componentFactoryResolver: ComponentFactoryResolver
	) {
		super(broadcastService);
	}

	ngOnInit(): void {
		if (this.data) {
			const orderId = this.data.source === ORIGIN.Nexsys
				? this.data.nexsysOrderId
				: this.data.valutrustOrderId;
			this.OrderBaseLog = [
				{ name: `${this.data.source} OrderId `, value: orderId ? orderId : this.data.valueLinkOrderId},
				{ name: 'ClassOrderId', value: this.data.classOrderId },
				{ name: 'TransactionId', value: this.data.transactionId }
			];
			const { messageRequest, request, response, errorMessage } = this.data.trans;
			this.OrderTransLog = {
				messageRequest,
				request,
				response,
				errorMessage
			};
		}
		this.openSubContent(null, null);
	}

	/**
	 * open modal request info
	 */
	displayRequestInfo(): void {
		this.modalService
			.open({
				componentFactoryResolver: this.componentFactoryResolver,
				component: RequestInformationLogComponent,
				data: {
					reuqest: this.OrderTransLog
				},
				modalConfiguration: {
					title: 'Payload Information',
					modalSize: ModalSize.XXL
				}
			})
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(result => {
				if (result.status === 'accept' && result.definition) {
					//
				}
			});
	}

	/**
	 * On component destroy
	 */
	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
